import React, { useState, useEffect } from 'react';
import { CloseCircleFilled, InfoCircleFilled, PlusCircleOutlined, EyeFilled } from '@ant-design/icons';
import { Tooltip, Input, Button, Select } from 'antd';
import TickIcon from '../../../assets/images/tick-icon-filled.svg';
import Specialities from '../../../components/common/Specialities';
import { useDispatch, useSelector } from 'react-redux';
import { MCIIconColor, PracticeIconColor, RegistrationNumberIconColor, SpecialityPlaceholder } from '../../../utilities/resources';
import { EDIT_PROFILE, FETCH_SPECIALITIES } from '../../../actions/types';
import MCIUpload from '../../../components/common/MCIUpload';
import { INDIA_COUNTRY_CODE, MCI_UPLOAD_STEP, STEPS_IN_PROFILE_COMPLETION } from '../../../utilities/appStatics';
import Img from '../../../components/common/Img';
import ModalBox from '../../../components/common/ModalBox';
import { isPdf, openNotificationInToast, reloadPage } from '../../../utilities';
import { updateMciCountryService } from '../../../services/profile';

const { Option } = Select;

function MedicalDetails(props) {
  const { userDetails } = props;
  const {
    data: { specialities },
    countries,
  } = useSelector((state) => state.listings);
  const [visible, setVisible] = useState(false);
  const [isMedicalRegistrationNumber, setIsMedicalRegistrationNumber] = useState(false);
  const [medicalRegistrationNumber, setMedicalRegistrationNumber] = useState('');
  const [MCIUploadModal, setMCIUploadModal] = useState(false);
  const [specialitiesOfInterest, setSpecialitiesOfInterest] = useState([]);
  const [visibleMCIModal, setVisibleMCIModal] = useState(false);
  const [mciCountryDetails, setMciCountryDetails] = useState({});
  const [newMciCountry, setNewMciCountry] = useState('');
  const [showMciCountryChange, setShowMciCountryChange] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: FETCH_SPECIALITIES,
    });
  }, []);

  const verifyIfUserCountryCodeIsPresent = () => {
    return userDetails.users && userDetails.users.userCountry && userDetails.users.userCountry.code;
  };

  useEffect(() => {
    const specialitiesOfInterestArr = userDetails.users.specialitiesOfInterestIdsStr.split(',');
    setSpecialitiesOfInterest(specialitiesOfInterestArr);

    if (userDetails && userDetails.users) {
      const verifyMCI = localStorage.getItem('verifyMCI');
      if (verifyMCI !== null && JSON.parse(verifyMCI)) {
        if (!userDetails.users.isRegistrationVerified) {
          setMCIUploadModal(true);
        } else {
          openNotificationInToast('info', '', 'MCI is already verified!');
          localStorage.removeItem('verifyMCI');
        }
      } else {
        setMCIUploadModal(false);
        localStorage.removeItem('verifyMCI');
      }
      if (userDetails.users.mciCountry) {
        setMciCountryDetails(userDetails.users.mciCountry);
      } else if (userDetails.users.userCountry) {
        setMciCountryDetails(userDetails.users.userCountry);
      }
    }
  }, [userDetails]);

  const getRegistrationStatus = (data) => {
    if (data === '0') {
      return 'Not Uploaded';
    } else if (data === '1') {
      return 'Under Verification';
    } else if (data === '2') {
      return 'Verified';
    } else if (data === '3') {
      return 'Rejected';
    }
  };

  const handleMedicalRegistrationNumberChange = (ev) => {
    const value = ev.target.value;
    setMedicalRegistrationNumber(value);
  };

  const submitMedicalRegistrationNumber = () => {
    dispatch({
      type: EDIT_PROFILE,
      payload: { registrationId: medicalRegistrationNumber.trim() },
    });
  };

  const checkIfMCIUploadIsOptional = () => {
    let check = false;
    STEPS_IN_PROFILE_COMPLETION.forEach((step) => {
      if (step.name === MCI_UPLOAD_STEP && !step.forAllUsers && verifyIfUserCountryCodeIsPresent() && step.forUserCountries.indexOf(userDetails.users.userCountry.code) < 0) {
        check = true;
      }
    });
    return check;
  };

  const closeMCIUploadModal = () => {
    setMCIUploadModal(false);
    localStorage.removeItem('verifyMCI');
  };

  const handleMciChangeCancel = () => {
    setShowMciCountryChange(false);
    setNewMciCountry('');
  };

  const handleMciCountrySave = () => {
    if (newMciCountry !== '') {
      updateMciCountryService(newMciCountry)
        .then((response) => {
          openNotificationInToast('success', 'Success!', 'Medical Registration Country has been updated successfully!');
          setTimeout(() => {
            reloadPage();
          }, 1000);
        })
        .catch((error) => console.log(error));
    }
  };

  return userDetails ? (
    <div>
      <Specialities visible={visible} setVisible={setVisible} />
      <div className='heading_title profile_cards_title headingSpace'>Medical Details</div>
      <div className='specialitiesContainer fadeIn-up' style={{ animationDelay: '0.6s' }}>
        <div className='specialitiesContainer_title'>Specialities of Interest</div>
        <div className='specialityListContainer specCardsContainer'>
          <div className='add_speciality' onClick={() => setVisible(true)}>
            <p>Add a Speciality</p>
            <PlusCircleOutlined className='addIcon' />
          </div>
          {specialities.map((speciality) =>
            specialitiesOfInterest.map((items) => {
              if (speciality.id == items.trim()) {
                return (
                  <div className='specCards specCardsSize'>
                    <div className='specMedia'>
                      <Img src={speciality.icon} defaultSrc={SpecialityPlaceholder} alt={speciality.name} />
                    </div>
                    <p className='specName'>{speciality.name}</p>
                  </div>
                );
              }
            })
          )}
        </div>
      </div>
      <div className='profileMatrixContainer'>
        {userDetails.users.specialitiesString && (
          <div className='profileMatrix fadeIn-up' style={{ animationDelay: '0.8s' }}>
            <img src={PracticeIconColor} />
            <div className='profileMatrixInner'>
              <p className='profile_title'>Field of Study</p>
              <div className='profile_content'>
                {userDetails.users.specialitiesString}
                {!userDetails.users.specialitiesString ? <span className='profile_actionText'>Add Specialities</span> : null}
              </div>
            </div>
          </div>
        )}
        {verifyIfUserCountryCodeIsPresent() && userDetails.users.userCountry.code === INDIA_COUNTRY_CODE && (
          <div className='profileMatrix fadeIn-up' style={{ animationDelay: '1s' }}>
            <img src={RegistrationNumberIconColor} />
            <div className='profileMatrixInner'>
              <p className='profile_title'>Medical Registration ID</p>
              {checkIfMCIUploadIsOptional() ? (
                <Tooltip title={userDetails.users.registrationId ? 'Updated' : 'Not Updated'}>
                  {userDetails.users.registrationId ? (
                    <img src={TickIcon} alt='Tick Icon' className='profileStatusIcon' style={{ width: 16 }} />
                  ) : (
                    <InfoCircleFilled style={{ color: '#ffa500' }} className='profileStatusIcon' />
                  )}
                </Tooltip>
              ) : (
                <Tooltip title={getRegistrationStatus(userDetails.users.registrationStatus)}>
                  {!checkIfMCIUploadIsOptional() ? (
                    userDetails.users.registrationStatus === '1' ? (
                      <InfoCircleFilled style={{ color: '#ffa500' }} className='profileStatusIcon' />
                    ) : userDetails.users.registrationStatus === '2' ? (
                      <img src={TickIcon} alt='Tick Icon' className='profileStatusIcon' style={{ width: 16 }} />
                    ) : (
                      <CloseCircleFilled style={{ color: '#f02f72' }} className='profileStatusIcon' />
                    )
                  ) : (
                    ''
                  )}
                </Tooltip>
              )}

              <div className='profile_content'>
                <span>{userDetails.users.registrationId}</span>
                <div className='profile_actions'>
                  {isMedicalRegistrationNumber ? (
                    <span onClick={() => setIsMedicalRegistrationNumber(false)}>Cancel</span>
                  ) : !checkIfMCIUploadIsOptional() && userDetails.users.registrationStatus === '2' ? null : (
                    <span onClick={() => setIsMedicalRegistrationNumber(true)}>{userDetails.users.registrationId ? 'Change' : 'Enter'}</span>
                  )}
                </div>
              </div>
              {isMedicalRegistrationNumber && (
                <div className='profileMatrixUpdate'>
                  <Input value={medicalRegistrationNumber} onChange={handleMedicalRegistrationNumberChange} placeholder='Enter Medical Registration Number' />
                  <Button onClick={submitMedicalRegistrationNumber} disabled={medicalRegistrationNumber === '' ? true : false} type='primary' size='small' style={{ height: 32, marginLeft: 5 }}>
                    Submit
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
        <div className='profileMatrix fadeIn-up' style={{ animationDelay: '1.2s' }}>
          <img src={MCIIconColor} />
          <div className='profileMatrixInner'>
            <p className='profile_title'>
              Medical Registration Certificate
              {userDetails.users && userDetails.users.registrationCertificate && (
                <Tooltip title='Uploaded MCI'>
                  <span onClick={() => setVisibleMCIModal(true)} className='certificateViewIcon'>
                    <EyeFilled />
                  </span>
                </Tooltip>
              )}
              <span className='color_black_3'>{checkIfMCIUploadIsOptional() ? ' (Optional)' : ''}</span>
            </p>
            <Tooltip title={getRegistrationStatus(userDetails.users.registrationStatus)}>
              {userDetails.users.registrationStatus === '1' ? (
                <InfoCircleFilled style={{ color: '#ffa500' }} className='profileStatusIcon' />
              ) : userDetails.users.registrationStatus === '2' ? (
                <img src={TickIcon} alt='Tick Icon' className='profileStatusIcon' style={{ width: 16 }} />
              ) : !checkIfMCIUploadIsOptional() ? (
                <CloseCircleFilled style={{ color: '#f02f72' }} className='profileStatusIcon' />
              ) : (
                ''
              )}
            </Tooltip>
            <div className='profile_content'>
              <span>{getRegistrationStatus(userDetails.users.registrationStatus)}</span>
              <div className='profile_actions'>
                {userDetails.users.registrationStatus === '0' ? (
                  <span onClick={() => setMCIUploadModal(true)}>Upload Now</span>
                ) : userDetails.users.registrationStatus === '1' || userDetails.users.registrationStatus === '3' ? (
                  <span onClick={() => setMCIUploadModal(true)}>Re-upload</span>
                ) : null}
              </div>
            </div>
            {userDetails.users.mciRejectReason && <div className='mciRejection'>Reason: {userDetails.users.mciRejectReason}</div>}
          </div>
        </div>
        <div className='profileMatrix'>
          <img src={mciCountryDetails.flag} />
          <div className='profileMatrixInner'>
            <p className='profile_title'>Medical Registration Country</p>
            <div className='profile_content'>
              {mciCountryDetails.name}
              {showMciCountryChange ? null : userDetails.users.isRegistrationVerified ? (
                ''
              ) : (
                <div className='profile_actions' onClick={() => setShowMciCountryChange(true)}>
                  <span>Change</span>
                </div>
              )}
            </div>
            {showMciCountryChange && (
              <div className='mciCountrySelection'>
                <Select
                  showSearch
                  placeholder='Choose Country'
                  optionFilterProp='children'
                  defaultValue={mciCountryDetails.id}
                  onChange={(val) => setNewMciCountry(val)}
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  style={{ minWidth: 180 }}
                  virtual={false}
                >
                  {countries.map((items, index) => {
                    return (
                      <Option key={index} value={items.id} disabled={items.id === mciCountryDetails.id}>
                        {items.name}
                      </Option>
                    );
                  })}
                </Select>
                <div className='profile_actions'>
                  <Button type='default' style={{ textDecoration: 'none' }} onClick={handleMciChangeCancel}>
                    Cancel
                  </Button>
                  <Button type='primary' disabled={newMciCountry === ''} style={{ textDecoration: 'none', marginLeft: 10 }} onClick={handleMciCountrySave}>
                    Save
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
        {verifyIfUserCountryCodeIsPresent() && userDetails.users.userCountry.code === INDIA_COUNTRY_CODE ? (
          mciCountryDetails.code === 'IN' ? (
            <div className='profileMatrix'>
              <img src={RegistrationNumberIconColor} />
              <div className='profileMatrixInner'>
                <p className='profile_title'>Medical Council</p>
                <div className='profile_content'>{userDetails.users.registrationRegionName}</div>
              </div>
            </div>
          ) : null
        ) : (
          ''
        )}
      </div>
      <MCIUpload MCIUploadModal={MCIUploadModal} setMCIUploadModal={closeMCIUploadModal} bodyStyles={{ textAlign: 'center' }} />
      <ModalBox title='Uploaded MCI' visible={visibleMCIModal} setVisible={setVisibleMCIModal}>
        <div className='mciViewModalBody'>
          {userDetails.users && userDetails.users.registrationCertificate ? (
            isPdf(userDetails.users.registrationCertificate) ? (
              <iframe src={userDetails.users.registrationCertificate} width='100%' style={{ minHeight: 400 }} />
            ) : (
              <img src={userDetails.users.registrationCertificate} alt='User Certificate' />
            )
          ) : null}
        </div>
      </ModalBox>
    </div>
  ) : null;
}

export default MedicalDetails;
